import React from 'react';
import { useDroppable } from '@dnd-kit/core';

const DroppablePriorityButton = ({ id, category, isSelected, info, onClick }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `priority-drop-${category}`,
  });

  return (
    <button
      ref={setNodeRef}
      onClick={onClick}
      className={`px-5 sm:px-8 py-2 sm:py-3 font-bold transition-all duration-200 rounded-[18px] border-2 ${info.color} ${info.textColor} ${isSelected ? 'scale-105 shadow-lg ring-2 ring-offset-2 ring-current opacity-100' : 'opacity-40 hover:opacity-60'} ${isOver ? 'scale-110 ring-4 ring-offset-2 brightness-110 opacity-100' : ''}`}
      data-testid={`priority-btn-${category}`}
    >
      <span className="block text-lg sm:text-lg">{category}</span>
      <span className="block text-[10px] sm:text-sm">{info.label}</span>
    </button>
  );
};

export default DroppablePriorityButton;
